import { isBelowBreakpoint } from '@/shared/helpers/responsiveness'

import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * Closes the mobile drawer whenever the route changes while it is open.
 * Acts as a safety net for navigations that do not go through a SideMenu
 * click handler: in-browser navigation (back/forward) and programmatic
 * redirects.
 */
export const useCloseOnRouteChange = (isOpen: boolean, setOpen: (open: boolean) => void): void => {
  const { pathname } = useLocation()
  const previousPathnameRef = useRef(pathname)

  useEffect(() => {
    if (pathname === previousPathnameRef.current) return
    previousPathnameRef.current = pathname
    if (isOpen && isBelowBreakpoint('lg')) {
      setOpen(false)
    }
  }, [pathname, isOpen, setOpen])
}
